import { useMemo } from 'react';
import { GraphDataError } from 'types/graphs';
import InfoIcon from '@mui/icons-material/Info';
import { SkullIcon } from '@wavetrak/theme';

const useCustomError = ({ error }: { error?: GraphDataError }) => {
  const rawError = useMemo(
    () => ({
      errorMessage:
        error?.statusCode === 400 && error?.message ? error.message : 'Something went wrong here.',
      errorIcon: error?.statusCode === 400 ? InfoIcon : SkullIcon,
      hasError: Boolean(error),
    }),
    [error],
  );

  return {
    errorMessage: rawError.errorMessage,
    ErrorIcon: rawError.errorIcon,
    hasError: rawError.hasError,
  };
};

export default useCustomError;
